<div class="back-to-list">
  <div class="navigation-left">
    <a class="arrow arrow-left" (click)="goBack()">{{ backToLabel }}</a>
  </div>
</div>

<mat-card>
  <mat-card-content>
    <form [formGroup]="form" (ngSubmit)="submit()">
      <app-select
        data-testid="selected-site-name"
        appearance="outline"
        *ngIf="sites"
        [control]="siteCtrl"
        [items]="sites"
        labelKey="account"
        optionTemplateName="site-icon">
      </app-select>

      <p>
        <mat-form-field appearance="outline" class="shrink" data-testid="scenario-name">
          <mat-label translate="scenario-wizard/name"></mat-label>
          <input #name matInput maxlength="200" formControlName="scenarioName" />
          <span class="text-muted" matSuffix>{{ name.value?.length || 0 }}/200</span>
          <mat-error
            translate="common/form_errors/required"
            *ngIf="form.get('scenarioName').hasError('required')"></mat-error>
        </mat-form-field>
      </p>
      <p translate="quick-replies/copy/name_already_exists" *ngIf="warningNameAlreadyExists"></p>

      <ng-container *ngIf="{ siteId: siteCtrl.valid, templates: templates$ | async } as data">
        <ng-container *ngIf="data.siteId && !duplicate">
          <p>
            <strong translate="scenario-wizard/choose-scenario-template"></strong>
          </p>

          <ng-container *ngIf="scenarioTemplatesLoading; else scenarioTemplatesLoaded">
            <p class="scenario-templates-loading">
              <app-loader></app-loader>
              <span translate="scenario-wizard/scenario-templates-loading"></span>
            </p>
          </ng-container>

          <ng-template #scenarioTemplatesLoaded>
            <ng-container *ngIf="data.templates?.length; else noScenarioTemplates">
              <div class="scenario-templates">
                <ng-container *ngFor="let template of data.templates">
                  <div
                    [attr.data-testid]="'scenario-template-' + template.id"
                    (click)="selectedScenarioTemplate = selectedScenarioTemplate === template.id ? null : template.id"
                    class="scenario-template"
                    [style.background-image]="template.previewURL"
                    [class.selected]="template.id === selectedScenarioTemplate">
                    <button
                      mat-icon-button
                      color="primary"
                      class="show-preview"
                      type="button"
                      *ngIf="template.previewURL"
                      (click)="showPreview(template)">
                      <mat-icon> open_in_new </mat-icon>
                    </button>
                    <div class="content">
                      <strong>{{ template.name }}</strong>
                      <p class="description">
                        {{ template.description }}
                      </p>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-template>
          <ng-template #noScenarioTemplates>
            <p translate="scenario-wizard/no-scenario-templates"></p>
          </ng-template>
        </ng-container>
      </ng-container>

      <button
        [disabled]="form.invalid || (!selectedScenarioTemplate && !duplicate)"
        mat-raised-button
        color="primary"
        type="submit">
        {{ (duplicate ? 'scenario-wizard/duplicate' : 'scenario-wizard/submit') | translate }}
      </button>
    </form>
  </mat-card-content>
</mat-card>
